export default __webpack_public_path__ + "static/epilogue-9359e963d0a3e31fb998972d1eca21bb.svg";